import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogContent, DialogTitle, Tabs, Tab, Chip, Box, Grid, TextField, Typography, Button, Paper, Snackbar, Alert, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import './CorrectionModal.css';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';

function TabPanel({ children, value, index }) {
  return (
    <div className={`cm-tab-panel${value !== index ? ' cm-hidden' : ''}`} role="tabpanel">
      {value === index && <div className="cm-tab-panel-content">{children}</div>}
    </div>
  );
}

const sectionLabels = [
  "Coordonnées", "Compétences Techniques", "Soft Skills",
  "Langues", "Formations", "Certifications", "Expériences"
];

const CorrectionModal = ({
  open, handleClose, data, model, talentId, onCVGenerated
}) => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://server.cooptaleo.com';
  const API_CORRECTIONS_URL = process.env.REACT_APP_API_CORRECTIONS_URL || 'https://cooptaleo.com/corrections';
  const [tab, setTab] = useState(0);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [skillInputs, setSkillInputs] = useState([]);
  const [localMessage, setLocalMessage] = useState({ text: '', severity: '' });

  // Snackbar messages
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const showMessage = (message, severity = 'info') => setSnackbar({ open: true, message, severity });
  const handleCloseSnackbar = () => setSnackbar(s => ({ ...s, open: false }));

  useEffect(() => {
    setForm(data || {});
  }, [data, open]);

  const handleFieldChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleAddLanguage = () => {
  setForm(prev => ({
    ...prev,
    languages: [...(prev.languages || []), { language: '', proficiency: '' }]
  }));
};

const handleAddSoftSkill = () => {
  setForm(prev => ({
    ...prev,
    soft_skills: [...(prev.soft_skills || []), '']
  }));
};

  const handleArrayFieldChange = (field, index, subField, value) => {
    setForm(prev => {
      const arr = Array.isArray(prev[field]) ? [...prev[field]] : [];
      arr[index] = { ...arr[index], [subField]: value };
      return { ...prev, [field]: arr };
    });
  };

  const handleSoftSkillChange = (index, value) => {
    setForm(prev => {
      const arr = Array.isArray(prev.soft_skills) ? [...prev.soft_skills] : [];
      arr[index] = value;
      return { ...prev, soft_skills: arr };
    });
  };

  const handleTechSkillChange = (index, sub, value) => {
    setForm(prev => {
      const arr = Array.isArray(prev.technical_skills) ? [...prev.technical_skills] : [];
      if (sub === "skills") {
        arr[index][sub] = value.split(',').map(s => s.trim());
      } else {
        arr[index][sub] = value;
      }
      return { ...prev, technical_skills: arr };
    });
  };

  const handleExperienceChange = (index, sub, value) => {
    setForm(prev => {
      const arr = Array.isArray(prev.professional_experiences) ? [...prev.professional_experiences] : [];
      if (sub === "tasks") {
        arr[index][sub] = value.split('\n');
      } else {
        arr[index][sub] = value;
      }
      return { ...prev, professional_experiences: arr };
    });
  };

  const handleAddEducation = () => {
  setForm(prev => ({
    ...prev,
    education: [...(prev.education || []), { date: '', title: '' }]
  }));
};


  const handleAddCertif = () => {
  setForm(prev => ({
    ...prev,
    certif: [...(prev.certif || []), { date: '', title: '' }]
  }));
};


  const handleAddExperience = () => {
  setForm(prev => ({
    ...prev,
    professional_experiences: [...(prev.professional_experiences || []), {
      period: '',
      role: '',
      client: '',
      project: '',
      tasks: [],
      technical_environment: ''
    }]
  }));
};


const handleRemoveLanguage = (index) => {
  setForm(prev => ({
    ...prev,
    languages: prev.languages.filter((_, i) => i !== index)
  }));
};

const handleRemoveSoftSkill = (index) => {
  setForm(prev => ({
    ...prev,
    soft_skills: prev.soft_skills.filter((_, i) => i !== index)
  }));
};

const handleRemoveEducation = (index) => {
  setForm(prev => ({
    ...prev,
    education: prev.education.filter((_, i) => i !== index)
  }));
};

const handleRemoveCertif = (index) => {
  setForm(prev => ({
    ...prev,
    certif: prev.certif.filter((_, i) => i !== index)
  }));
};

const handleRemoveExperience = (index) => {
  setForm(prev => ({
    ...prev,
    professional_experiences: prev.professional_experiences.filter((_, i) => i !== index)
  }));
};



  const handleSave = async () => {
    setSaving(true);
      setLocalMessage({ text: '', severity: '' });

    try {
      // 1. Enregistrement dans la BDD (corrections)
      await fetch(`${API_BASE}/api/cv-corrections/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          talentId,
          data: form,
          userId: localStorage.getItem('userId'),
        }),
      });

      // 2. Envoi à l'API Flask pour générer le PDF anonymisé
      const genRes = await fetch(`${API_CORRECTIONS_URL}/user-corrections`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, choice: model }),
      });
      if (!genRes.ok) throw new Error("Erreur lors de la génération du CV");

      const pdfBlob = await genRes.blob();
      {/*const url = window.URL.createObjectURL(pdfBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `cv_anonymise_${model}.pdf`;
      a.click();*/}

      // 3. Enregistrement du fichier dans le backend interne
      const formData = new FormData();
      formData.append('file', pdfBlob, 'cv_anonymise.pdf');
      formData.append('model', model);
      formData.append('talentId', talentId);
      formData.append('name', form.name || '');
      formData.append('title', form.title || '');
      formData.append('userId', localStorage.getItem('userId'));
      formData.append('recruteurName', localStorage.getItem('recruteurName'));

      const uploadRes = await fetch(`${API_BASE}/api/cv-generated/save`, {
        method: 'POST',
        body: formData,
      });
      if (!uploadRes.ok) throw new Error("Erreur lors de l'upload du CV généré");

      const result = await uploadRes.json();
          setLocalMessage({ text: "CV généré et sauvegardé avec succès !", severity: "success" });

      if (typeof onCVGenerated === "function") {
        onCVGenerated({ ...result.data, name: form.name, title: form.title });
      }

    setLocalMessage({ text: "CV généré et sauvegardé avec succès !", severity: "success" });
    } catch (err) {
      console.error(err);
    setLocalMessage({ text: "Erreur : " + err.message, severity: "error" });
    } finally {
      setSaving(false);
    }
  };


  const renderPreview = () => (
    <Paper className="cm-cv-preview" elevation={2}>
      <Typography variant="h6" className="cm-preview-title">
        {form?.name && <b>{form.name}</b>} {form?.title && <>– <span className="cm-preview-job">{form.title}</span></>}
      </Typography>
      <Typography className="cm-preview-contact">
        {/*form?.address} {form?.tel && <>| {form?.tel}</>} {form?.mail && <>| {form?.mail}</>*/}
      </Typography>
      <div className="cm-preview-section-title">Compétences techniques</div>
      {Array.isArray(form?.technical_skills) && form.technical_skills.map((sk, i) => (
        <div key={i} className="cm-preview-skill">{sk.domain}: <span className="cm-preview-skill-list">{sk.skills?.join(', ')}</span></div>
      ))}
      <div className="cm-preview-section-title">Soft Skills</div>
      {Array.isArray(form?.soft_skills) && form.soft_skills.map((s, i) => (
        <div key={i} className="cm-preview-soft">{s}</div>
      ))}
      <div className="cm-preview-section-title">Langues</div>
      {Array.isArray(form?.languages) && form.languages.map((l, i) => (
        <div key={i} className="cm-preview-lang">{l.language} : <span className="cm-preview-lang-lvl">{l.proficiency}</span></div>
      ))}
      <div className="cm-preview-section-title">Formations</div>
      {Array.isArray(form?.education) && form.education.map((e, i) => (
        <div key={i} className="cm-preview-edu">{e.date} : <span>{e.title}</span></div>
      ))}
      <div className="cm-preview-section-title">Certifications</div>
      {Array.isArray(form?.certif) && form.certif.map((c, i) => (
        <div key={i} className="cm-preview-cert">{c.date} : <span>{c.title}</span></div>
      ))}
      <div className="cm-preview-section-title">Expériences professionnelles</div>
      {Array.isArray(form?.professional_experiences) && form.professional_experiences.map((exp, i) => (
        <div key={i} className="cm-exp-block">
          <div className="cm-exp-head"><b>{exp.period}</b> – <span className="cm-exp-role">{exp.role}</span> {exp.client && `(Client: ${exp.client})`}</div>
          {exp.project && <div className="cm-exp-proj">Projet : <span>{exp.project}</span></div>}
          {Array.isArray(exp.tasks) &&
            <ul className="cm-task-list">
              {exp.tasks.map((t, j) => <li key={j}>{t}</li>)}
            </ul>
          }
          {exp.technical_environment &&
            <div className="cm-exp-tech">Environnement Technique : <span>{exp.technical_environment}</span></div>
          }
        </div>
      ))}
    </Paper>
  );

  return (
    <>
     <Dialog open={open} onClose={(e, r) => {
        if (r === 'backdropClick' || r === 'escapeKeyDown') return;
        handleClose();
      }} maxWidth="xl" fullWidth className={minimized ? 'cm-dialog-minimized' : ''}>

        <DialogTitle className="cm-dialog-title">
          <span>Correction des données extraites</span>
          <div className="cm-title-actions">
            <IconButton onClick={() => setMinimized(m => !m)} size="small" className="cm-minimize-btn">
              {minimized ? <OpenInFullIcon /> : <RemoveIcon />}
            </IconButton>
            <IconButton onClick={handleClose} size="small" className="cm-close-btn">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        {!minimized &&
        <DialogContent className="cm-modal-content">
           <div className="cm-modal-body">
              <div className="cm-modal-tabs">
                <Tabs orientation="vertical" value={tab} onChange={(_, v) => setTab(v)} className="cm-tabs">
                  {sectionLabels.map((label, idx) => <Tab key={idx} label={label} />)}
                </Tabs>
              <div className="cm-save-btn-container">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSave}
                  disabled={saving}
                  className="cm-save-btn"
                >
                  {saving ? "Génération..." : "Enregistrer et Générer"}
                </Button>

                {localMessage.text && (
                  <div
                    style={{
                      marginTop: 8,
                      color: localMessage.severity === 'success' ? 'green' : '#cc2d2d',
                      textAlign: 'center',
                      fontWeight: 500,
                      fontSize: 15,
                    }}
                  >
                    {localMessage.text}
                  </div>
                )}
              </div>


              </div>
              <div className="cm-modal-form">
                <TabPanel value={tab} index={0}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                      label="Trigramme"
                      fullWidth
                      value={form?.name || ''}
                      onChange={e => handleFieldChange('name', e.target.value)}
                    />
                    <TextField
                      label="Titre"
                      fullWidth
                      value={form?.title || ''}
                      onChange={e => handleFieldChange('title', e.target.value)}
                    />
                  {/* <TextField
                      label="Adresse"
                      fullWidth
                      value={form?.address || ''}
                      onChange={e => handleFieldChange('address', e.target.value)}
                    />
                    <TextField
                      label="Téléphone"
                      fullWidth
                      value={form?.tel || ''}
                      onChange={e => handleFieldChange('tel', e.target.value)}
                    />
                    <TextField
                      label="E-mail"
                      fullWidth
                      value={form?.mail || ''}
                      onChange={e => handleFieldChange('mail', e.target.value)}
                    />*/}
                  </Box> 
                </TabPanel>


                <TabPanel value={tab} index={1}>
                  {Array.isArray(form?.technical_skills) && form.technical_skills.map((sk, i) => {
                    // Pour l’input propre à ce domaine
                    const skillInput = skillInputs[i] || "";

                    const handleInputChange = (e) => {
                      const newInputs = [...skillInputs];
                      newInputs[i] = e.target.value;
                      setSkillInputs(newInputs);
                    };

                    const handleAddSkill = () => {
                      if (skillInput.trim() !== "") {
                        const newSkills = [...(sk.skills || []), skillInput.trim()];
                        handleTechSkillChange(i, "skills", newSkills.join(", "));
                        // Reset input seulement pour ce domaine
                        const newInputs = [...skillInputs];
                        newInputs[i] = "";
                        setSkillInputs(newInputs);
                      }
                    };

                    const handleInputKeyDown = (e) => {
                      if (e.key === "Enter") handleAddSkill();
                    };

                    // Supprimer un domaine complet
                    const handleDeleteDomain = (index) => {
                      setForm(prev => ({
                        ...prev,
                        technical_skills: prev.technical_skills.filter((_, idx) => idx !== index)
                      }));
                      setSkillInputs(inputs => inputs.filter((_, idx) => idx !== index));
                    };

                    return (
                      <Box key={i} className="cm-form-group" mb={3} sx={{ position: "relative", border: "1px solid #e2e6ea", borderRadius: 2, p: 2 }}>
                        <IconButton
                          aria-label="Supprimer ce domaine"
                          onClick={() => handleDeleteDomain(i)}
                          sx={{ position: "absolute", top: 8, right: 8, color: "#f44336" }}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                        <TextField
                          label={`Domaine ${i + 1}`}
                          value={sk.domain || ""}
                          onChange={e => handleTechSkillChange(i, "domain", e.target.value)}
                          fullWidth
                          sx={{ mb: 1 }}
                        />
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1 }}>
                          {(sk.skills || []).map((skill, j) => (
                            <Chip
                              key={j}
                              label={skill}
                              onDelete={() => {
                                const newSkills = sk.skills.filter((_, idx) => idx !== j);
                                handleTechSkillChange(i, "skills", newSkills.join(", "));
                              }}
                              color="primary"
                              variant="outlined"
                              // rendre chaque chip éditable :
                              onClick={() => {
                                const edit = prompt("Modifier la compétence :", skill);
                                if (edit && edit !== skill) {
                                  const newSkills = [...sk.skills];
                                  newSkills[j] = edit;
                                  handleTechSkillChange(i, "skills", newSkills.join(", "));
                                }
                              }}
                              sx={{ cursor: "pointer" }}
                            />
                          ))}
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <TextField
                            label="Ajouter compétence"
                            value={skillInput}
                            onChange={handleInputChange}
                            onKeyDown={handleInputKeyDown}
                            size="small"
                            sx={{ flexGrow: 1 }}
                          />
                          <IconButton onClick={handleAddSkill} color="primary">
                            <AddCircleOutlineIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    );
                  })}
                  {/* Ajouter un domaine */}
                  <Box sx={{ mt: 2 }}>
                    <Button
                      variant="outlined"
                      startIcon={<AddCircleOutlineIcon />}
                      onClick={() => {
                        setForm(prev => ({
                          ...prev,
                          technical_skills: [
                            ...(prev.technical_skills || []),
                            { domain: "", skills: [] }
                          ]
                        }));
                        setSkillInputs(inputs => [...inputs, ""]);
                      }}
                    >
                      Ajouter un domaine
                    </Button>
                  </Box>
                </TabPanel>


                <TabPanel value={tab} index={2}>
                  {Array.isArray(form?.soft_skills) && form.soft_skills.map((s, i) => (
                    <Box key={i} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <TextField
                        label={`Compétence ${i + 1}`}
                        value={s}
                        onChange={e => handleSoftSkillChange(i, e.target.value)}
                        fullWidth
                        className="cm-soft-skill-field"
                      />
                      <IconButton color="error" onClick={() => handleRemoveSoftSkill(i)}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  ))}
                  <Button onClick={handleAddSoftSkill} size="small" startIcon={<AddCircleOutlineIcon />} variant="outlined">
                    Ajouter une compétence
                  </Button>
                </TabPanel>


                <TabPanel value={tab} index={3}>
                  {Array.isArray(form?.languages) && form.languages.map((lg, i) => (
                    <Grid container spacing={2} key={i} className="cm-form-group" alignItems="center">
                      <Grid item xs={7}>
                        <TextField
                          label={`Langue ${i + 1}`}
                          value={lg.language || ''}
                          onChange={e => handleArrayFieldChange('languages', i, 'language', e.target.value)}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          label="Niveau"
                          value={lg.proficiency || ''}
                          onChange={e => handleArrayFieldChange('languages', i, 'proficiency', e.target.value)}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <IconButton color="error" onClick={() => handleRemoveLanguage(i)}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}
                  <Button onClick={handleAddLanguage} size="small" startIcon={<AddCircleOutlineIcon />} sx={{ mt: 1 }} variant="outlined">
                    Ajouter une langue
                  </Button>
                </TabPanel>

                <TabPanel value={tab} index={4}>
                  {Array.isArray(form?.education) && form.education.map((ed, i) => (
                    <Grid container spacing={2} key={i} className="cm-form-group" alignItems="center">
                      <Grid item xs={5}>
                        <TextField
                          label={`Date ${i + 1}`}
                          value={ed.date || ''}
                          onChange={e => handleArrayFieldChange('education', i, 'date', e.target.value)}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label={`Intitulé ${i + 1}`}
                          value={ed.title || ''}
                          onChange={e => handleArrayFieldChange('education', i, 'title', e.target.value)}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <IconButton color="error" onClick={() => handleRemoveEducation(i)}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}
                  <Button onClick={handleAddEducation} size="small" startIcon={<AddCircleOutlineIcon />} variant="outlined">
                    Ajouter une formation
                  </Button>
                </TabPanel>


<TabPanel value={tab} index={5}>
  {Array.isArray(form?.certif) && form.certif.map((c, i) => (
    <Grid container spacing={2} key={i} className="cm-form-group" alignItems="center">
      <Grid item xs={5}>
        <TextField
          label={`Date ${i + 1}`}
          value={c.date || ''}
          onChange={e => handleArrayFieldChange('certif', i, 'date', e.target.value)}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label={`Intitulé ${i + 1}`}
          value={c.title || ''}
          onChange={e => handleArrayFieldChange('certif', i, 'title', e.target.value)}
          fullWidth
        />
      </Grid>
      <Grid item xs={1}>
        <IconButton color="error" onClick={() => handleRemoveCertif(i)}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  ))}
  <Button onClick={handleAddCertif} size="small" startIcon={<AddCircleOutlineIcon />} variant="outlined">
    Ajouter une certification
  </Button>
</TabPanel>



<TabPanel value={tab} index={6}>
  {Array.isArray(form?.professional_experiences) && form.professional_experiences.map((exp, i) => (
    <Paper key={i} className="cm-exp-paper">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="subtitle2" className="cm-exp-label">Expérience {i + 1}</Typography>
        <IconButton color="error" onClick={() => handleRemoveExperience(i)}>
          <DeleteIcon />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField label="Période" value={exp.period || ''} onChange={e => handleExperienceChange(i, 'period', e.target.value)} fullWidth />
        <TextField label="Titre" value={exp.role || ''} onChange={e => handleExperienceChange(i, 'role', e.target.value)} fullWidth />
        <TextField label="Client" value={exp.client || ''} onChange={e => handleExperienceChange(i, 'client', e.target.value)} fullWidth />
        <TextField label="Projet" value={exp.project || ''} onChange={e => handleExperienceChange(i, 'project', e.target.value)} fullWidth />
        <TextField label="Missions" value={Array.isArray(exp.tasks) ? exp.tasks.join('\n') : ''} multiline minRows={3} onChange={e => handleExperienceChange(i, 'tasks', e.target.value)} fullWidth />
        <TextField label="Environnement technique" value={exp.technical_environment || ''} onChange={e => handleExperienceChange(i, 'technical_environment', e.target.value)} fullWidth />
      </Box>
    </Paper>
  ))}
  <Button onClick={handleAddExperience} size="small" startIcon={<AddCircleOutlineIcon />} variant="outlined" sx={{ mt: 1 }}>
    Ajouter une expérience
  </Button>
</TabPanel>



            </div>
            <div className="cm-modal-preview">
              {renderPreview()}
            </div>
          </div>
        </DialogContent>
        }
      </Dialog>

      {/* Snackbar pour affichage des messages */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CorrectionModal;
